export default {
  active_orders: {
    title: 'Aktive ordrer',
  },
  order_history: {
    title: 'Ordrehistorik',
  },
  menu: {
    title: 'Menu',
  },
  printer_settings: {
    title: 'Printerindstillinger',
  },
  order_control: {
    title: 'Ordrestyring',
  },
  busy_mode: {
    title_zero: 'Travlhedstilstand',
    title_other: 'Travlhedstilstand (+{{time}} min)',
  },
  volume: {
    title: 'Lydstyrke',
  },
  switch_language: {
    title: 'Skift sprog ({{language}})',
  },
  logout: {
    title: 'Log ud',
    description: 'Er du sikker på, at du vil logge ud?',
    buttons: {
      confirm: 'Ja',
      cancel: 'Annuller',
    },
  },
};
